import React from "react";
import ProductTableItem from "./TableItem";
import ProductTableItemMobile from "./TableItemMobile";
import CheckboxCostumAuth from "components/Auth/atoms/forms/CheckboxCostum";

import styles from "./MainApp.organisms.Product.Table.module.scss";
import i18n from "i18n";
export class ProductTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: false,
      selected: null,
    };
  }

  handleSelectAll = () => {
    let selectAll = this.state.selectAll;
    this.setState({
      selectAll,
    });
    if (this.props.handleSelectAll) this.props.handleSelectAll();
  };

  handleSelectOne = (selected) => {
    if (this.state.selected === selected) {
      selected = null;
    }
    this.setState({
      selectAll: false,
      selected,
    });
  };

  render() {
    const { products, headers, headerClickHandler, handleClickProduct } = this.props;
    const table = (
      <React.Fragment>
        <div className={styles["table-desktop"]} data-automation-id="product-table">
          <div className={styles["table-header"]}>
            {/* <div className={`${styles["table-header-item"]} ${styles["table-header-checkbox"]}`}>
              <CheckboxCostumAuth
                handleChange={this.handleSelectAll}
                checked={this.state.selectAll}
              ></CheckboxCostumAuth>
            </div> */}
            <div className={`${styles["table-header-item"]} ${styles["table-header-image"]}`}></div>
            <div data-automation-id="sort-by-name" onClick={() => { headerClickHandler('name') }} data-filter-name='name' className={`${styles["table-header-item"]} ${styles["table-header-name"]}`}>
              {i18n.t("name").toUpperCase()} <span className={`${styles["table-header-icon-span"]} ${headers.name.active ? styles["active"] : ""}  ${headers.name.direction ? "" : styles["down"]}`}><i className={"icon-iconos_flecha-ordenar"}></i></span>
            </div>
            <div data-automation-id="sort-by-brand" onClick={() => { headerClickHandler('brand_name') }} data-filter-name='brand_name' className={`${styles["table-header-item"]} ${styles["table-header-brand"]}`}>
              {i18n.t("brand").toUpperCase()} <span className={`${styles["table-header-icon-span"]} ${headers.brand_name.active ? styles["active"] : ""}  ${headers.brand_name.direction ? "" : styles["down"]}`}><i className={"icon-iconos_flecha-ordenar"}></i></span>
            </div>
            <div data-automation-id="sort-by-sku" onClick={() => { headerClickHandler('sku') }} data-filter-name='sku' className={`${styles["table-header-item"]} ${styles["table-header-code"]}`}>
              {i18n.t("code").toUpperCase()} <span className={`${styles["table-header-icon-span"]} ${headers.sku.active ? styles["active"] : ""}  ${headers.sku.direction ? "" : styles["down"]}`}><i className={"icon-iconos_flecha-ordenar"}></i></span>
            </div>
            <div data-automation-id="sort-by-categoria" onClick={() => { headerClickHandler('categories__name') }} data-filter-name='categories__name' className={`${styles["table-header-item"]} ${styles["table-header-category"]}`}>
              {i18n.t("categories").toUpperCase()} <span className={`${styles["table-header-icon-span"]} ${headers.categories__name.active ? styles["active"] : ""}  ${headers.categories__name.direction ? "" : styles["down"]}`}><i className={"icon-iconos_flecha-ordenar"}></i></span>
            </div>
            {/* <div data-automation-id="sort-by-stock" onClick={() => {headerClickHandler('stock')}} data-filter-name='stock' className={`${styles["table-header-item"]} ${styles["table-header-stock"]}`}>
              STOCK <span className={`${styles["table-header-icon-span"]} ${headers.stock.active ? "active" : ""}  ${headers.stock.direction ? "" : "down"}`}> <i className="icon-iconos_flecha-ordenar"></i></span>
            </div> */}
            <div className={`${styles["table-header-item"]} ${styles["table-header-button"]}`}></div>
          </div>
          <div className={styles["table-content"]}>
            {products.map((product) => {
              return (
                <div className={styles["table-content-item"]} key={product.id}>
                  <ProductTableItem
                    product={product}
                    isSelected={
                      this.state.selected === product.id || this.state.selectAll
                    }
                    handleSelect={this.handleSelectOne}
                    handleClick={handleClickProduct}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles["table-mobile"]} data-automation-id="product-table">
          <div className={styles["table-content"]}>
            {products.map((product) => {
              return (
                <div className={styles["table-content-item"]} key={product.id}>
                  <ProductTableItemMobile
                    product={product}
                    isSelected={
                      this.state.selected === product.id || this.state.selectAll
                    }
                    handleSelect={this.handleSelectOne}
                    handleClick={handleClickProduct}

                  />
                </div>
              );
            })}
          </div>
        </div>
      </React.Fragment>
    );

    return <div className={styles["table-container"]}>{table}</div>;
  }
}

ProductTable.propTypes = {};

export default ProductTable;

